import { GUEST_STATUS_COLORS, PAYMENT_SUMMARY_TOTAL_LABEL, PAYMENT_SUMMARY_PAID_LABEL, PAYMENT_SUMMARY_BALANCE_LABEL } from '../constants/bookingConst';
import { formatMoney } from '../utils/currencyUtil';
import { getPaymentBreakdown, describePartialPaymentTag } from '../utils/partialPaymentUtil';
import '../css/ConfirmationPaymentSummary.css';

/**
 * The money lines at the bottom of the guest's confirmation screen.
 *
 * A full payment is the single "Total Paid" line it always was. A partial
 * payment — the guest ticked "Partial payment" at checkout — shows the full
 * total, what they actually paid (tagged with the percentage) and the
 * remaining balance: the same three figures the booking email and the PDF
 * carry, from the same getPaymentBreakdown().
 *
 * Must sit inside a `.user-info-form` ancestor for the shared uif-* row
 * styles (UserInfoForm.css).
 *
 * @param {object} props
 * @param {object} props.bookingData - the submitted booking; paymentAmount is the full total
 * @param {object} props.config - club config, for currency and the partial-payment switch
 * @returns {JSX.Element}
 */
function ConfirmationPaymentSummary({ bookingData, config }) {
  const breakdown = getPaymentBreakdown(bookingData, config);

  if (!breakdown) {
    return (
      <div className="uif-total-row">
        <span>{PAYMENT_SUMMARY_PAID_LABEL}</span>
        <span className="uif-total-amt">{formatMoney(Number(bookingData.paymentAmount || 0), config)}</span>
      </div>
    );
  }

  return (
    <div className="cps-partial">
      <div className="uif-total-row cps-total-row">
        <span>{PAYMENT_SUMMARY_TOTAL_LABEL}</span>
        <span className="cps-total-amt">{formatMoney(breakdown.total, config)}</span>
      </div>
      <div className="cps-paid-row">
        <span className="cps-paid-label">
          {PAYMENT_SUMMARY_PAID_LABEL}
          <span className="cps-tag">{describePartialPaymentTag(breakdown)}</span>
        </span>
        <span className="uif-total-amt">{formatMoney(breakdown.amountPaid, config)}</span>
      </div>
      <div className="cps-balance-row" style={{ color: GUEST_STATUS_COLORS.pending }}>
        <span>{PAYMENT_SUMMARY_BALANCE_LABEL}</span>
        <span className="cps-balance-amt">{formatMoney(breakdown.balance, config)}</span>
      </div>
    </div>
  );
}

export default ConfirmationPaymentSummary;
